module.exports = __webpack_public_path__ + "img/candle.227b7bc0.png";